var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 19 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70455 25C1.25 25 0.852273 24.8295 0.511364 24.4886C0.170455 24.1477 0 23.75 0 23.2955V8.83523C0 8.38068 0.170455 7.98295 0.511364 7.64205C0.852273 7.30114 1.25 7.13068 1.70455 7.13068H6.50568V8.83523H1.70455V23.2955H16.4773V8.83523H11.6193V7.13068H16.4773C16.9318 7.13068 17.3295 7.30114 17.6705 7.64205C18.0114 7.98295 18.1818 8.38068 18.1818 8.83523V23.2955C18.1818 23.75 18.0114 24.1477 17.6705 24.4886C17.3295 24.8295 16.9318 25 16.4773 25H1.70455ZM8.21023 16.2784V3.29545L5.71023 5.79545L4.48864 4.57386L9.0625 0L13.6364 4.57386L12.4148 5.79545L9.91477 3.29545V16.2784H8.21023Z",
    fill: "#484888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.ddb735e799d92f32e5388993d8efbc25.svg";
export { ForwardRef as ReactComponent };